import React, {useMemo} from 'react';
import {TouchableOpacity, View} from 'react-native';

import Icon from '/component/base/Icon';
import {Shared} from '/constant/TestIDs';
import {withTheme} from '/provider/ThemeProvider';
import {dodgerBlue} from '/theme/color/on.color';
import {withHOC} from '/util/hoc.util';
import testProperties from '/util/testing/testProperties';

import {createDynamicStyles, styles} from './ChatIcon.style';

interface ChatIconProps {
  onPress: () => void;
  getTheme: (key: string) => string | undefined;
}

const ChatIcon: React.FC<ChatIconProps> = ({onPress, getTheme}) => {
  const primaryColor =
    getTheme('competency.backgroundColor.color') || dodgerBlue;
  const dynamicStyles = useMemo(
    () => createDynamicStyles(primaryColor),
    [primaryColor],
  );

  return (
    <TouchableOpacity
      style={[styles.container, dynamicStyles.containerBackground]}
      onPress={onPress}
      activeOpacity={0.8}
      accessibilityLabel="Open chat"
      accessibilityRole="button"
      {...testProperties(Shared.chatButton)}>
      <View style={styles.iconContainer}>
        <Icon name="message" style={styles.icon} />
      </View>
    </TouchableOpacity>
  );
};

export default withHOC(withTheme)(ChatIcon);
